import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "truncate"
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, truncateLen: number): string {
    if (value === null) return;

    let limit = truncateLen > 0 ? truncateLen : 10;
    let trail = "...";

    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/truncate.pipe.ts